import { send_tracking_event } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/tracking/send_tracking_event.js?1733898722584';

export function send_result_tracking_event(result, tracking_id) {
    if (result?.goControl) {
        // control group, sometimes empty
        send_tracking_event('odoscope', tracking_id);
    } else {
        if (result?.variants?.length === 0) {
            // empty variant
            send_tracking_event('odoscope/empty', tracking_id);
        } else {
            // everythings fine
            send_tracking_event('odoscope', tracking_id);
        }
    }
}
